export default __webpack_public_path__ + "static/media/advantage2.139d6bfc.svg";